import { PanelType } from "@fluentui/react";
import { PanelGenerico } from "../../components/generic/PanelGenerico";
import themeBase from "../../utils/theme/themeBase";
import BaseTelelirk from "../../components/generic/baseTelerik";
import { BaseReportesTelerik } from "../../components/generic/baseReportesTelerik";


interface Idsp {
    isOpen: boolean | undefined
    onDismiss: ((ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => void) | undefined
}

function ReporteEnrolados(props: Idsp) {

    return (
        <>
            <PanelGenerico
                isOpen={props.isOpen}
                onDismiss={props.onDismiss}
                enabledFooter={true}
                panelType={PanelType.large}
                enabledHeader={true}
                HeaderTitlesText={{ title: "Reporte Usuarios Enrolados" }}
            >
                <div style={themeBase._padding20}>
                    {/* <BaseTelelirk reportName="SSOMAUsuariosEnrolados.trdx" parametros={{}} /> */}
                    <BaseReportesTelerik
                        reportName="SSOMAUsuariosEnrolados.trdx"
                        parametros={{}}
                        formatos={2}
                    />
                </div>
            </PanelGenerico>
        </>
    );
}

export default ReporteEnrolados;

